import { ReactNode } from "react";

import { Box, ButtonBase, Chip, Paper, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export interface AppCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  chip?: string | null;
  disabled?: boolean;
  onClick: () => void;
}

const AppCard = ({
  title,
  description,
  icon,
  chip,
  disabled = false,
  onClick,
}: AppCardProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        opacity: disabled ? 0.5 : 1,
        transition: "opacity 0.2s ease-in-out",
      }}
    >
      <ButtonBase
        onClick={() => {
          if (!disabled) {
            onClick();
          }
        }}
        disabled={disabled}
        sx={{
          width: "100%",
          textAlign: "left",
        }}
      >
        <Paper
          sx={{
            p: 2,
            width: "100%",
            backgroundColor: theme.palette.background.paper,
            transition: "transform 0.2s ease-in-out",
            "&:hover": {
              transform: "scale(1.02)",
            },
          }}
          elevation={4}
        >
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                color: theme.palette.primary.main,
                display: "flex",
              }}
            >
              {icon}
            </Box>
            <Typography variant="h6" component="h2" sx={{ fontWeight: "bold" }}>
              {title}
            </Typography>
            {chip && (
              <Chip
                label={chip}
                size="small"
                sx={{
                  ml: 1,
                  bgcolor: theme.palette.grey[900],
                  color: theme.palette.common.white,
                }}
              />
            )}
          </Box>
          <Typography
            variant="body2"
            sx={{
              mt: 1,
              ml: 6,
              color: theme.palette.text.secondary,
            }}
          >
            {description}
          </Typography>
        </Paper>
      </ButtonBase>
    </Box>
  );
};

export default AppCard;
